import fs from 'node:fs'

export function isCLICreatedOxcConfig(configPath: string): boolean {
  if (!fs.existsSync(configPath)) return false
  try {
    const content = JSON.parse(fs.readFileSync(configPath, 'utf-8'))
    return (
      typeof content.$schema === 'string' &&
      content.$schema.includes('node_modules/ox') &&
      Array.isArray(content.ignorePatterns) &&
      content.ignorePatterns.includes('**/.betterstart/snapshots/**/files/**')
    )
  } catch {
    return false
  }
}
